export const isRodaJCAction = () => {
    const path = window.location.pathname;
    const hostname = window.location.hostname;
    const isCorrectDomain = hostname.includes('cleanenergy');
    const isRodaJCPath = path.includes("/rodajc/bereken-jouw-maandbedrag");
    return isCorrectDomain && isRodaJCPath ? 1 : 0;
};

// Controleert of "zelfopwek" getoond moet worden
export const shouldShowZelfopwek = (chosenProduct, returnsAvailableForAgent, calledByVerbruikComponent = false, skipProductCheck = false, productAllowsReturn = false) => {
    // De functie afhankelijk maken van isRodaJCAction
    let isRodaJcActie = isRodaJCAction() ? true : false;
    if (!skipProductCheck) {
        var chosenProductIncludesElectriciteit = chosenProduct.includes('Electriciteit');
    } else {
        var chosenProductIncludesElectriciteit = true;
    }
    // If this function is called by the component that allows the user to set their expected usage/return amount.
    if (calledByVerbruikComponent) {
        return (isRodaJcActie || returnsAvailableForAgent) && chosenProductIncludesElectriciteit;
    } else {
        return (isRodaJcActie || (returnsAvailableForAgent && productAllowsReturn)) && chosenProductIncludesElectriciteit;
    }
};